export default __webpack_public_path__ + "static/media/project10.f9ee7f22.png";